import {Component, OnInit} from "@angular/core";
import {provideSearchModel} from "@fedelta-pos/data-client";
import {LoadingService} from "../../ui-elements/loading/loading.service";
import {Page} from "../../orchestration/page";
import {MessageLevel} from "../../notification/message/message";
import {IdentityModel} from "../../identity/identity.model";
import {OrderModel} from "../../order/order.model";
import {NavigationService} from "../../orchestration/navigation.service";
import {SessionModel} from "../../orchestration/session.model";
import {OrderingContextModel} from "../../ordering-context/ordering-context.model";
import {MemberSalesData, MemberSalesSearchModel} from "../../identity/member-sales-search.model";
import {MemberRecentSaleData} from "../../identity/member-summary-entity.model";
import {RecentOrderData, RecentOrderService} from "../../order/recent-order.service";
import {StoreData} from "../../store/store-search.model";
import {OrderType} from "../../order/order";

@Component({
    selector: "woa-customer-orders-page",
    templateUrl: "./customer-orders-page.component.html",
    providers: [
        {provide: Page, useExisting: CustomerOrdersPageComponent},
        provideSearchModel(MemberSalesSearchModel)
    ]
})
export class CustomerOrdersPageComponent extends Page implements OnInit {
    MessageLevel = MessageLevel;
    OrderType = OrderType;

    public loadingFailed: boolean = false;
    public isLoading: boolean;
    public recentOrders: RecentOrderData[] = [];

    constructor(public memberSalesSearchModel: MemberSalesSearchModel,
                public identityModel: IdentityModel,
                public orderModel: OrderModel,
                public sessionModel: SessionModel,
                private orderingContextModel: OrderingContextModel,
                private recentOrderService: RecentOrderService,
                private navigationService: NavigationService,
                private loadingService: LoadingService) {
        super();
    }

    ngOnInit(): void {
        this.isLoading = true;
        this.loadingFailed = false;

        // noinspection JSIgnoredPromiseFromCall
        this.loadingService.performWithSpinner(async () => {
            if (this.identityModel.currentMember && !this.identityModel.isGuestUser) {
                try {
                    await this.memberSalesSearchModel.retrieve(10000);
                } catch (error) {
                    this.loadingFailed = true;
                }
                this.recentOrderService.purgeOldOrders(this.identityModel.currentMember.recentSales.map((recentSale: MemberRecentSaleData) => recentSale.orderLookupCode));
            }
            this.recentOrders = this.recentOrderService.recentOrders.filter((recentOrder: RecentOrderData) => !recentOrder.convertedToSale);
            this.isLoading = false;
        }, undefined, "woa.message.orders.loading");
    }

    get saleCount(): number {
        return this.recentOrders.length + this.memberSalesSearchModel.data.length;
    }

    getOrderDescription(recentOrder: RecentOrderData): string {
        return "woa.common.order." +
            (recentOrder.orderInitiation.orderTypeEnum === OrderType.ORDER_AHEAD ? "ahead"
                : recentOrder.orderInitiation.orderTypeEnum === OrderType.ORDER_DELIVERY ? "delivery"
                    : recentOrder.orderInitiation.orderTypeEnum === OrderType.ORDER_AT_TABLE ? "atTable" : "") +
            ".order.noun";
    }

    getOrderMessage(recentOrder: RecentOrderData, store: StoreData): string {
        const canShowEta: boolean = this.orderingContextModel.canShowETAForStore(store);
        const etaPast: boolean = recentOrder.placedOrder.estimatedCompletionDateTime && recentOrder.placedOrder.estimatedCompletionDateTime < new Date();
        return recentOrder.orderInitiation.transferTargetId ? "woa.message.order.summary.transferredToGroupOrder"
            : recentOrder.orderInitiation.orderTypeEnum === OrderType.ORDER_AT_TABLE ? "woa.message.order.summary.orderPlaced"
                : !canShowEta ? (
                        etaPast ? (recentOrder.orderInitiation.orderTypeEnum === OrderType.ORDER_AHEAD ? "woa.message.order.summary.asapPickupTimePast" : "woa.message.order.summary.asapDeliveryTimePast")
                            : (recentOrder.orderInitiation.orderTypeEnum === OrderType.ORDER_AHEAD ? "woa.message.order.summary.asapPickupTime" : "woa.message.order.summary.asapDeliveryTime")
                    )
                    : recentOrder.initiatedOrder.orderLaterDateTime ? (recentOrder.orderInitiation.orderTypeEnum === OrderType.ORDER_AHEAD ? "woa.message.order.summary.scheduledPickupTime" : "message.order.summary.scheduledDeliveryTime")
                        : etaPast ? (recentOrder.orderInitiation.orderTypeEnum === OrderType.ORDER_AHEAD ? "woa.message.order.summary.estimatedPickupTimePast" : "woa.message.order.summary.estimatedDeliveryTimePast")
                            : (recentOrder.orderInitiation.orderTypeEnum === OrderType.ORDER_AHEAD ? "woa.message.order.summary.estimatedPickupTime" : "woa.message.order.summary.estimatedDeliveryTime");
    }

    getOrderTime(recentOrder: RecentOrderData): string {
        return !recentOrder.initiatedOrder.orderLaterDateTime ? recentOrder.placedOrder.estimatedCompletionTime
            : recentOrder.placedOrder && recentOrder.placedOrder.estimatedCompletionTime ? this.orderModel.formatEstimatedCompletionDateTime(recentOrder.placedOrder)
                : this.orderModel.formatRequiredDateTime(recentOrder.initiatedOrder);
    }

    getSaleDescription(sale: MemberSalesData): string {
        return "woa.label.sale-summary.sale-description." +
            (sale.storeId ? "online" : "inStore") +
            (sale.saleType === MemberSalesData.DELIVERY ? "Delivery"
                : sale.saleType === MemberSalesData.TAKEAWAY ? "Takeaway"
                    : sale.saleType === MemberSalesData.APP_AT_TABLE ? "AppAtTable"
                        : "Order");
    }

    async viewOrderDetails(recentOrder: RecentOrderData): Promise<void> {
        return this.navigationService.createPage("woa-order-details-page", {recentOrder});
    }

    async viewReceipt(sale: MemberSalesData): Promise<void> {
        return this.navigationService.createPage("woa-sale-receipt-page", {sale: sale});
    }

    async requestInvoice(sale: MemberSalesData): Promise<void> {
        return this.navigationService.createPage("woa-invoice-request-page", {sale: sale});
    }
}



// WEBPACK FOOTER //
// ./src/app/customer-info/customer-orders-page/customer-orders-page.component.ts